import { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'

import { Taskmodel } from 'taskmodel/shared/types'

type ActionHandlerType = {
  object_uuid_source_container_property_name: string
}

type DataContainerType = {
  [key: string]: string
}

export type ActionHandlerProps = {
  taskmodel?: Taskmodel
  workflowUuid?: string
  dataContainer: DataContainerType
}

type ActionHandlerResponse = {
  url: string
  label: string
}

const initialValue = {
  url: '',
  label: ''
}

const useActionHandler = ({
  taskmodel,
  workflowUuid,
  dataContainer
}: ActionHandlerProps): ActionHandlerResponse => {
  const [state, setState] = useState<ActionHandlerResponse>(initialValue)

  const [searchParams] = useSearchParams()
  const hideInteractionContainer =
    searchParams.has('hideInteractionContainer') ?? false

  useEffect(() => {
    let url = ''

    if (taskmodel?.interactionmodel_actionhandler) {
      url = `/interaction/${workflowUuid}/${getInteractionModelUuid(taskmodel)}${hideInteractionContainer ? `?hideInteractionContainer=true` : ''}`
    } else if (taskmodel?.waitforsituation_actionhandler) {
      url = `/masterdata/${workflowUuid}/${getObjectUuid(
        taskmodel.waitforsituation_actionhandler,
        dataContainer
      )}`
    } else if (taskmodel?.waitforstatus_actionhandler) {
      url = `/masterdata/${workflowUuid}/${getObjectUuid(
        taskmodel.waitforstatus_actionhandler,
        dataContainer
      )}`
    }

    setState({
      url: url,
      label: taskmodel?.des ?? ''
    })
  }, [taskmodel, workflowUuid, dataContainer, hideInteractionContainer])

  return { url: state.url, label: state.label }
}

const getInteractionModelUuid = (taskmodel: Taskmodel) =>
  taskmodel.interactionmodel_actionhandler?.interactionmodel_uuid

const getObjectUuid = (
  actionhandler: ActionHandlerType,
  dataContainer: DataContainerType
) => {
  return actionhandler !== undefined
    ? dataContainer[actionhandler.object_uuid_source_container_property_name]
    : null
}

export default useActionHandler
